import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';
import {
  fetchApplication,
  removeApplication,
  updateApplication,
} from 'store/api/applications/application/applicationActions';
import { submitForm } from 'store/api/submitForm/submitForm';
import {
  ApplicationDetailsResponse,
  ApplicationType,
  RemoveApplicationResponse,
  UpdateApplicationPayload,
  UpdateApplicationResponse,
} from 'store/api/types';

import { Application } from './Application';
import { ApplicationProps } from './Application.types';

const mapDispatchToProps = (dispatch: Dispatch, { match: { params } }: ApplicationProps) => ({
  onFetchApplication: () =>
    dispatch<Promise<ApplicationDetailsResponse>>(
      fetchApplication(params.accountId, params.applicationId, ApplicationType.PSD2),
    ),
  onRemoveApplication: submitForm<RemoveApplicationResponse>(dispatch, () =>
    removeApplication(params.accountId, params.applicationId, ApplicationType.PSD2),
  ),
  onUpdateApplication: submitForm<UpdateApplicationResponse>(dispatch, values =>
    updateApplication(params.accountId, params.applicationId, ApplicationType.PSD2, values as UpdateApplicationPayload),
  ),
});

export const ApplicationContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(Application);
